import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismComboSelectInput } from '@mylighthouse/prism-ember';
import compareStringArrays from 'lumen/utils/compare-arrays';
import { findOptionById } from 'lumen/utils/pms-mapping-utils';

interface SettingsMappingTableCellCategoryDropdownBenchmarkSignature {
  Args: {
    column: unknown;
    row: unknown;
  };
}

export default class SettingsMappingTableCellCategoryDropdownBenchmark extends Component<SettingsMappingTableCellCategoryDropdownBenchmarkSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isDisabled() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      // @ts-expect-error: Incorrect type
      this.args.column.disableRowActions ||
      // @ts-expect-error: Incorrect type
      this.args.row.readOnly ||
      // @ts-expect-error: Incorrect type
      this.args.column.isMappingDisabled
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get options() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const options = this.args.column.categoryOptions;
    // @ts-expect-error: Incorrect type
    const { suggestedCategoryId } = this.args.row;

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return options.map((option) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (suggestedCategoryId && suggestedCategoryId === option.id) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return {
          ...option,
          badge: this.intl.t('benchmark_insight.pms.mapping.suggestion'),
        };
      }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return option;
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get selectedCategory() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-argument
    let option = findOptionById(this.options, this.args.value);
    // @ts-expect-error: Incorrect type
    const { id } = option;
    // @ts-expect-error: Incorrect type
    const { suggestedCategoryId } = this.args.row;
    if (id === null && suggestedCategoryId !== null) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-argument
      option = findOptionById(this.options, suggestedCategoryId);
    }
    return option;
  }

  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  categoryMatcher(categoryObject, searchTerm) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
    return compareStringArrays(categoryObject.label, searchTerm) ? 1 : -1;
  }

  @action
  // @ts-expect-error: Incorrect type
  onChange(option): void {
    // @ts-expect-error: Incorrect type
    const { suggestedCategoryId } = this.args.row;
    const pmsMappingValue = this.args.row;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const optionId = option.id === suggestedCategoryId ? null : option.id;

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    pmsMappingValue.categoryId = optionId;
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.args.column.onChangeCategory(pmsMappingValue);
  }

  <template>
    <div class="flex flex-col">
      <PrismComboSelectInput
        @disabled={{this.isDisabled}}
        @isSearchable={{true}}
        @onChange={{this.onChange}}
        @options={{this.options}}
        @searchMatcher={{this.categoryMatcher}}
        @value={{this.selectedCategory}}
      />
    </div>
  </template>
}
